export const BASE_UNISWAP_V3_CONTRACT_ADDRESS = '0x08a7002fa14a8Fc4E1Fd76a13734DCe647FFEe92';
export const BASE_DCKS_CONTRACT_ADDRESS = '0xA363f32426AD97Bbd79f85a9C4F967A3E20145AB';
export const PRIMARY_SITE_HOST = 'www.reddicks.meme';
export const PRIMARY_SITE_URL = `https://${PRIMARY_SITE_HOST}`;
export const DEX_SITE_HOST = 'dex.reddicks.meme';
export const DEX_SITE_URL = `https://${DEX_SITE_HOST}`;
export const SWAP_SITE_HOST = 'swap.reddicks.meme';
export const SWAP_SITE_URL = `https://${SWAP_SITE_HOST}`;
export const RSWAP_SWAP_URL = `${DEX_SITE_URL}/swap`;
export const RSWAP_STAKING_URL =
  `${DEX_SITE_URL}/token/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp/staking`;
export const RSWAP_STAKING_WIDGET_URL =
  `${DEX_SITE_URL}/widget/staking/resource_rdx1t42hpqvsk4t42l6aw09hwphd2axvetp6gvas9ztue0p30f4hzdwxrp`;
export const SWAP_WIDGET_URL =
  'https://feature-reddicks-rebrand-reddicks.defiplaza.workers.dev/widget/swap';

export const BASE_UNISWAP_V3_CONTRACT_URL = `https://basescan.org/address/${BASE_UNISWAP_V3_CONTRACT_ADDRESS}`;
export const BASE_DCKS_CONTRACT_URL = `https://basescan.org/token/${BASE_DCKS_CONTRACT_ADDRESS}`;
export const BASE_DCKS_CONTRACT_CODE_URL = `https://basescan.org/address/${BASE_DCKS_CONTRACT_ADDRESS}#code`;

export const BASE_BUY_URL = `https://app.uniswap.org/swap?chain=base&outputCurrency=${BASE_DCKS_CONTRACT_ADDRESS}`;
export const BASE_CHART_URL = `https://dexscreener.com/base/${BASE_UNISWAP_V3_CONTRACT_ADDRESS}`;
export const BASE_DEXTOOLS_URL = `https://www.dextools.io/app/base/pair-explorer/${BASE_UNISWAP_V3_CONTRACT_ADDRESS}`;
export const BASE_TEAM_FINANCE_LOCK_URL =
  `https://www.team.finance/view-coin/${BASE_DCKS_CONTRACT_ADDRESS}?name=REDDICKS&symbol=DCKS&chainid=0x2105`;
export const RADIX_BUY_URL = 'https://www.caviarnine.com/trade';
export const RADIX_CHARTS_URL = 'https://www.caviarnine.com/charts';
export const ASTROLESCENT_BRIDGE_URL = 'https://astrl.trade/';

export const BASE_POOL_CONTRACT_URL = BASE_UNISWAP_V3_CONTRACT_URL;
export const BASE_LOCK_URL = BASE_TEAM_FINANCE_LOCK_URL;
export const NO_MINT_PROOF_URL = BASE_DCKS_CONTRACT_CODE_URL;
export const SUPPLY_PROOF_URL = BASE_DCKS_CONTRACT_URL;
export const BASE_PAIR_LABEL = 'DCKS / cbETH';
export const BASE_PAIR_ADDRESS = BASE_UNISWAP_V3_CONTRACT_ADDRESS;
export const BASE_LOCK_END_LABEL = 'April 4, 2027';
export const BASE_PROOF_SUMMARY =
  'Base liquidity is live and publicly locked, with Team Finance as the primary proof surface and DEXTools as the supporting explorer.';

export const SITE_CONTENT = {
  hero: {
    headline: 'Reddicks on Base. Locked. Live. Backed by receipts.',
    subline: 'Base LP Lock | Team Finance Proof | 1% Fee | Ecosystem-Funded',
  },
};
